const perf = {
    API_DOMAIN: 'https://api-nft.pearson.com/gps/',
    ALS_DOMAIN: 'https://preprod.pearsonactivelearn.com/',
    ALS_MARK_BOOK: 'app/reports/markbook/list',
    ENVIRONMENT: 'stg'
};
export default perf;
